<template>
    <div class="row">
        <div class="col-md-12">
            <div class="bsp-green">
                <div class="row mb-1"> 
                    <div class="col-md-auto">{{ data[0]?.Tahun ?? (selectedyears[0] ?? '-') }}</div> 
                    <div class="col"><span class="text-center w-100" style="font-size:10px;">{{ title }}</span></div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="d-flex align-items-center mb-2 ms-1"><div class="w-100 text-right">Rp. {{ formatNum(data[0]?.AverageBasket ?? 0) }}</div></div>
                        <div>{{ data[1]?.Tahun ?? (selectedyears[1] ?? '-') }}</div>
                        <div class="d-flex align-items-center mb-1"><div class="w-100 text-right">Rp. {{ formatNum(data[1]?.AverageBasket ?? 0) }}</div></div>
                    </div>
                    <div class="col-md-auto text-center ps-2 me-2 mt-3">
                        <div>{{ formatNum((((data[0]?.AverageBasket ?? 0)-(data[1]?.AverageBasket ?? 0))/(data[0]?.AverageBasket ?? 0)) * 100) }}%</div>
                        <div><i class="fa fa-shopping-cart bsp-icon-green"></i></div>
                    </div>										
                </div>
                <div class="text-center">BASKET SIZE (Jt IDR)</div>
            </div>
            <Loader v-if="loading" />
        </div>
    </div>
</template>


<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Fuel,
	components:{
		Loader,
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	props: {
        title: {
            type: String,
            default: 'NET SALES',
            //required: false,
        },
        year: {
            type: String,
            default: '2024',
            //required: false,
        },
        area: {
            type: String,
            default: '',
            //required: false,
        },
        amount :{
            type: String,
            default: '0',
            //required: false,
        },
        years: {
            type: Array,
            default: () => ['2024'],
            //required: false,
        },
        data: {
			type: Array,
			default: () => []
		},
        loading: {
            type: Boolean,
            default: false,
        },
    },
	data() {
		return {
            selectedyears : this.years.slice().sort((a, b) => b - a), //this.years,
			reportdata: [],
            value: 0,
            /*
			loading: {
				table: false,
				chart: false,
			},
            */
		}
	},
	watch: {
        years: {
            handler(newVal) {
                this.selectedyears = newVal.slice().sort((a, b) => b - a);
            },
            immediate: true,
            deep: true
        }
	}, 
	computed: {
        /*
		totalOutstanding() {
			return this.reportdata.data.reduce((sum, item) => sum + item.Count, 0);
		},
        */
	},

    mounted() {
		//this.getData();
    },
    methods:{
		
	}
}
</script>


<style>
.bsp-green {
	background-color: #E2F0D9; 
	border-radius:6px; 
	border-left: 20px solid #548235;
	padding: 6px 8px;
	color: #548235;
	font-weight: bold;
}

.bsp-icon-green {
	font-size:30px;
}

.text-ellipsis {
    white-space: nowrap;         /* Mencegah teks membungkus ke baris berikutnya */
    overflow: hidden;            /* Menyembunyikan teks yang melebihi lebar kontainer */
    text-overflow: ellipsis;
}
</style>